import { getDocs, collection } from "firebase/firestore";
import { db } from "../config/firebase";

const namesByIdsService = {
  // ✅ ULTRA-OPTIMIZED: Only load lookup data that's actually needed
  getEventLookups: async (eventData) => {
    if (!eventData) return {};
    
    try {
      // ✅ OPTIMIZED: Only load collections that have IDs in the event data
      const promises = [];
      const collections = [];
      
      if (eventData.team_id) {
        promises.push(getDocs(collection(db, "teams")));
        collections.push('teams');
      }
      if (eventData.division_id) {
        promises.push(getDocs(collection(db, "divisions")));
        collections.push('divisions');
      }
      if (eventData.relationship_id) {
        promises.push(getDocs(collection(db, "relationships")));
        collections.push('relationships');
      }
      if (eventData.spend_type_id) {
        promises.push(getDocs(collection(db, "spend_types")));
        collections.push('spend_types');
      }
      if (eventData.event_type_id) {
        promises.push(getDocs(collection(db, "event_types")));
        collections.push('event_types');
      }
      if (eventData.activity_type_id) {
        promises.push(getDocs(collection(db, "activity_types")));
        collections.push('activity_types');
      }
      if (eventData.external_source_id) {
        promises.push(getDocs(collection(db, "external_sources")));
        collections.push('external_sources');
      }
      if (eventData.organization_id) {
        promises.push(getDocs(collection(db, "organizations")));
        collections.push('organizations');
      }
      if (eventData.brand_id) {
        promises.push(getDocs(collection(db, "brands")));
        collections.push('brands');
      }

      if (promises.length === 0) return {};

      const results = await Promise.all(promises);
      
      const lookupMaps = {};
      let resultIndex = 0;
      
      collections.forEach(collectionName => {
        if (results[resultIndex]) {
          lookupMaps[collectionName] = new Map(
            results[resultIndex].docs.map(doc => [doc.id, doc.data().name])
          );
        }
        resultIndex++;
      });

      return {
        teamName: lookupMaps.teams?.get(eventData.team_id) || "",
        divisionName: lookupMaps.divisions?.get(eventData.division_id) || "",
        relationshipName: lookupMaps.relationships?.get(eventData.relationship_id) || "",
        spendTypeName: lookupMaps.spend_types?.get(eventData.spend_type_id) || "",
        eventTypeName: lookupMaps.event_types?.get(eventData.event_type_id) || "",
        activityTypeName: lookupMaps.activity_types?.get(eventData.activity_type_id) || "",
        externalSourceName: lookupMaps.external_sources?.get(eventData.external_source_id) || "",
        organizationName: lookupMaps.organizations?.get(eventData.organization_id) || "",
        brandName: lookupMaps.brands?.get(eventData.brand_id) || ""
      };
    } catch (error) {
      console.error('Error fetching event lookups:', error);
      return {};
    }
  },
};

export default namesByIdsService;
